import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { routes } from "@shared/lib/react-router";
import { ProjectRegistry } from "./ui";

export function ProjectRegistryRoute(...rest: RouteObject[]): RouteObject {
  return {
    path: routes.project.actRegistry(),
    element: createElement(ProjectRegistry),
    children: rest,
  };
}
